<div class="pd" *ngIf="showForm">
    <div *ngIf="verifyIdentity == false">
    <form nz-form [formGroup]="identificationForm">
        <nz-form-item>
        <nz-col nzSpan="24">
            <nz-form-label nzFor="identification_option">
            {{'PROFILE.USER-IDENTIFICATION.TYPE' | translate}}</nz-form-label
            >
        </nz-col>
        <nz-col [nzXs]="24" [nzSm]="24" [nzLg]="14" [nzXl]="12">
            <nz-form-control
            nzErrorTip="{{'PROFILE.USER-IDENTIFICATION.SELECT_PROMPT' | translate}}"
            >
            <nz-select
                nzName="radiogroup"
                formControlName="identification_option"
                (ngModelChange)="meansIdentificationChanged($event)"
                nzPlaceHolder="{{'PROFILE.USER-IDENTIFICATION.SELECT_PROMPT' | translate}}"
                name="identification_option"
                id="identification_option"
                nzDisabled
            >
                <nz-option
                *ngFor="let identity of identificationList"
                [nzLabel]="identity.name"
                [nzValue]="identity.code"
                ></nz-option>
            </nz-select>
            </nz-form-control>
        </nz-col>
        </nz-form-item>
        <nz-form-item *ngIf="IdentificationType == userVerificationTypes.FACE_MATCH_2">
        <nz-col [nzXs]="24" [nzSm]="24" [nzLg]="14" [nzXl]="12">
            <img
            class="user-image"
            src="{{ userImage }}"
            [alt]="alts.USER_VERIFICATION_IMAGE"
            />
        </nz-col>
        </nz-form-item>
        <nz-form-item *ngIf="IdentificationType != userVerificationTypes.FACE_MATCH_2">
        <nz-col [nzXs]="24" [nzSm]="24" [nzLg]="14" [nzXl]="12">
            <nz-form-label nzFor="name"> {{'PROFILE.USER-IDENTIFICATION.NUMBER' | translate}}</nz-form-label>
            <nz-form-control>
            <input
                nz-input
                name="number"
                formControlName="number"
                type="text"
                id="name"
                readonly
            />
            </nz-form-control>
        </nz-col>
        </nz-form-item>
    </form>
    </div>

    <div *ngIf="verifyIdentity == true">
    <h4>{{'PROFILE.USER-IDENTIFICATION.VERIFY_IDENTITY' | translate}}:</h4>
    <nz-form-control
        [nzSm]="12"
        [nzXs]="12"
        [nzMd]="8"
        [nzLg]="6"
        [nzXl]="4"
    >
        <button
        nz-button
        [nzType]="'primary'"
        [nzLoading]="loading"
        (click)="onVerify()"
        nzBlock
        >
        {{'PROFILE.USER-IDENTIFICATION.VERIFY_IDENTITY' | translate}}
        </button>
    </nz-form-control>
    </div>
</div> 

<!-- User Verification -->
<nz-modal
  [nzStyle]="{ top: '20px' }"
  [nzMask]="true"
  nzMaskClosable="false"
  nzWidth="900px"
  nzClosable="true"
  [(nzVisible)]="userInformationVerification"
  nzTitle="{{'PROFILE.USER-IDENTIFICATION.MODAL_TITLE' | translate}}"
  [nzContent]="modalContentUserVerification"
  (nzOnCancel)="cancelMeansofIdentificationModal()"
>
  <ng-template #modalContentUserVerification>
    <app-user-verification
      (successResponse)="identityVerified($event)"
      (closeModal)="cancelMeansofIdentificationModal()"
      [step]="userInformationWindowStep"
      [year]="year"
      [actions]="processStepsModalKeys.VIEW_CERTIFICATE"
    ></app-user-verification>
  </ng-template>
  <div *nzModalFooter></div>
</nz-modal>

